import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { useGoalsQuery } from '../../api/useGoalsQuery';

interface Props {
  clientId: string;
  control: Control<any>;
}

export const AssetBucketingSelect = ({ clientId, control }: Props) => {
  const { data } = useGoalsQuery({ clientId });

  if (!data) {
    return null;
  }

  const {
    assetBucketingOptions: { enableGoalAssetBucketing, availableBuckets },
  } = data;

  if (!enableGoalAssetBucketing) {
    return null;
  }

  const options = Object.values(availableBuckets).map((bucket, index) => ({
    label: bucket,
    value: index,
  }));

  return (
    <Controller
      control={control}
      name="assetBucketingIndices"
      render={({ field: { value, onChange } }) => (
        <Select
          isMulti
          isPortal
          label="Asset Bucketing"
          value={options.filter(opt => value.includes(opt.value))}
          options={options}
          onChange={opts => onChange((opts || []).map(opt => opt.value))}
        />
      )}
    />
  );
};
